import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import OptionPopupView from "views/common/OptionPopupView";
import PersistentModels from "services/PersistentModels";
import ti18n from "i18n!nls/MyLibraryi18n";
import popupTemplate from 'text!../../../templates/mylibrary/LibrarySortAndFilterOptionTemplate.html';

const LibrarySortAndFilterOptionView = OptionPopupView.extend({

    
    initialize: function(options) {
        const viewOptions = {};
        const contentView = {};
        const contentViewTemplate = _.template(popupTemplate);
        const templateParams = {};
        templateParams.ti18n = ti18n;
        contentView.$el = $(contentViewTemplate(templateParams));
        this._filterSelectionListView = options.filterSelectionListView?options.filterSelectionListView: null;
        if(this._filterSelectionListView){
            contentView.$el.find("#filterSelectionListContainer").append(this._filterSelectionListView.$el);
        }
        
        this._sortSelectionListView = options.sortSelectionListView?options.sortSelectionListView: null;
        if(this._sortSelectionListView){
            contentView.$el.find("#sortSelectionListContainer").append(this._sortSelectionListView.$el);
        }
        
        viewOptions.contentView = contentView;
        viewOptions.addContentAfterEnhancement = true;
        viewOptions.contentPosition = "center";
        this._popupUniqueId = "myLirbarySortAndFilterPopupView" + (new Date()).getTime();
        viewOptions.id = this._popupUniqueId;
        OptionPopupView.prototype.initialize.call(this, viewOptions);
        PersistentModels.getInstance().getRouter().registerForViewportHeightChange(this._popupUniqueId,this.onOrientationChangeFunction.bind(this), true);
    },
    
    onOrientationChangeFunction  : function(newViewPortHeigh, forceResizing) {
        if(this.$el.is(":visible") || forceResizing){
            if (this.el) {
                const adjustedListContainerHeight = (newViewPortHeigh) ;
                this.$el.find(".ui-content").css("height", adjustedListContainerHeight + "px");
            }
        }
    },

    afterRendering: function() {
       
    },

    
    onPopupClosed: function() {
        OptionPopupView.prototype.onPopupClosed.call(this);
        PersistentModels.getInstance().getRouter().unRegisterForViewportHeightChange(this._popupUniqueId, true);
        this.trigger("popupClosed");
    },

    
    onAfterPageShow: function() {
    //this.$el.find("#comment").focus();
        this.onOrientationChangeFunction(PersistentModels.getInstance().getRouter().getViewportHeight(), true);
    },



});

export default LibrarySortAndFilterOptionView;
